import { EditIntegrationWebComponent } from './component/EditIntegrationWebComponent';
import { WEB_COMPONENT_INTEGRATION_EDIT_INTEGRATION } from '../../webcomponents.constants';

export { EditIntegrationWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_EDIT_INTEGRATION, EditIntegrationWebComponent);
